import { useFormContext, Controller } from 'FrontRoyalReactHookForm';
import { generateGuid } from 'guid';
import { TextField as MuiTextField, type StandardTextFieldProps } from '@mui/material';

type Props = StandardTextFieldProps & {
    name: string;
};

export const TextField = ({ name, slotProps, defaultValue = '', ...rest }: Props) => {
    const { control, getFieldState } = useFormContext();
    const { error, isTouched } = getFieldState(name);

    // slot props can be an object or an ownerState callback; only the object form can be merged
    const inputSlotProps = typeof slotProps?.input === 'object' ? slotProps.input : {};
    const htmlInputSlotProps = typeof slotProps?.htmlInput === 'object' ? slotProps.htmlInput : {};

    const mergedSlotProps: StandardTextFieldProps['slotProps'] = {
        ...slotProps,
        input: {
            error: isTouched && !!error,
            ...inputSlotProps,
        },
        htmlInput: {
            ...htmlInputSlotProps,
            style: {
                ...htmlInputSlotProps.style,
                resize: rest?.multiline ? 'vertical' : undefined,
            },
        },
    };
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={({ field }) => (
                <MuiTextField
                    id={generateGuid()}
                    {...field}
                    value={field.value || ''}
                    {...rest}
                    slotProps={mergedSlotProps}
                />
            )}
        />
    );
};

export default TextField;
